export const CyCrewJoiner = {
  AlertSuccess: "AlertSuccess",
  ButtonOk: "ButtonOk",
} as const;
